import { supabase } from '../auth/supabaseClient'

const LAST_SEEN_KEY = 'pt_notify_last_seen'

export type NotificationItem = {
  id: string
  user_id: string
  from_user_id: string | null
  type: string
  payload?: any
  created_at: string
}

export async function notifyFriends(type: string, payload: any): Promise<number> {
  try {
    const { data, error } = await (supabase as any).rpc('notify_friends', { p_type: type, p_payload: payload })
    if (error) throw error
    return data as number
  } catch {
    return 0
  }
}

export async function fetchNewNotifications(): Promise<NotificationItem[]> {
  try {
    const { data: auth } = await supabase.auth.getSession()
    const userId = auth.session?.user?.id
    if (!userId) return []
    const since = (() => { try { return localStorage.getItem(LAST_SEEN_KEY) || '' } catch { return '' } })()
    let q = supabase.from('notifications').select('*').eq('user_id', userId).order('created_at', { ascending: true }).limit(50)
    if (since) q = q.gt('created_at', since)
    const { data, error } = await q
    if (error || !data || data.length === 0) return []
    // bump last seen
    try { localStorage.setItem(LAST_SEEN_KEY, data[data.length - 1].created_at) } catch { /* ignore */ }
    return data as NotificationItem[]
  } catch {
    return []
  }
}

export function markAllSeen(ts?: string) {
  try { localStorage.setItem(LAST_SEEN_KEY, ts || new Date().toISOString()) } catch { /* ignore */ }
}
